import { Crud, httpClient, HttpClient, QueryParameter } from 'lib/HttpClient';
import { AdjustmentScheme, AdjustmentSchemeType } from './adjustmentSchemeModel';
import { DEFAULT_PAGE_LIMIT } from 'lib/hooks/usePagedData';

const DEFAULT_QUERY_PARAMS: QueryParameter[] = [
    { key: 'schemeType', value: AdjustmentSchemeType.COUPON },
    { key: 'limit', value: DEFAULT_PAGE_LIMIT.toString() }
];
class AdjustmentSchemesApi extends Crud {
    constructor(client: HttpClient) {
        super(client, process.env.API_SERVER_URL, 'adjustmentschemes');
    }

    async getAllSchemes() {
        let nextKey: string;
        let endOfData = false;
        let loadedSchemes: AdjustmentScheme[] = [];
        let ok = true;

        while (!endOfData) {
            try {
                const queryParams: QueryParameter[] = nextKey
                    ? [...DEFAULT_QUERY_PARAMS, { key: 'startKey', value: nextKey }]
                    : DEFAULT_QUERY_PARAMS;

                const { body } = await this.getList({
                    queryParameters: queryParams
                });

                if (!body.items) {
                    throw new Error('Failed to load schemes');
                }

                loadedSchemes = [
                    ...loadedSchemes,
                    ...body.items.map((item: AdjustmentScheme) => ({ ...item, id: item._id }))
                ];

                nextKey = body.page.nextKey;

                if (!body.page.nextKey) {
                    endOfData = true;
                }
            } catch (err) {
                endOfData = true;
                ok = false;
            }
        }

        return { items: loadedSchemes, ok };
    }
}

export const adjustmentSchemesApi = new AdjustmentSchemesApi(httpClient);
